import PolicyPageLayout from "../components/PolicyPageLayout";

const sections = [
  {
    title: "Use of website",
    body: [
      "QA Coder content is provided for learning, practice, and career preparation. Users should not copy, misuse, or redistribute course material without permission.",
      "Practice pages are designed for educational automation testing and should be used responsibly.",
    ],
  },
  {
    title: "Accounts and access",
    body: [
      "Users are responsible for keeping their login details secure. QA Coder may restrict access for inactive, blocked, or misused accounts.",
      "Trainer and admin access may require approval and can be changed based on operational needs.",
    ],
  },
  {
    title: "Course participation",
    body: [
      "Course schedules, demo availability, and mentoring support may vary by batch. Final course details should be confirmed with QA Coder before payment.",
      "Job support includes guidance, resume help, and interview preparation, but does not guarantee employment.",
    ],
  },
];

export default function TermsPage() {
  return (
    <PolicyPageLayout
      eyebrow="Terms"
      title="Terms and Conditions"
      description="Basic terms for using QA Coder learning content, practice tools, accounts, and course services."
      sections={sections}
    />
  );
}
